import { formatUnitOfTime } from "../../../containers/MyClockings/ClockingsList/utils";
import { AtLegalEntityDTO } from "../../at-legal-entity";
import { EmployeeRef } from "../../employees";
import { TnAClockingLocationQRCodeRef } from "../../tna-clocking-location-qr-code";
import { TnALocationCodeRef } from "../../tna-location-codes/tna-location-code-ref";
import { TnAClockingTypeRef } from "../tna-clocking-types/tna-clocking-type-ref";
import { TnADateTime } from "../tna-data/tna-date-time";

export class TnAClockingDTO extends AtLegalEntityDTO {
  employee: EmployeeRef | null = null;
  clockingType: TnAClockingTypeRef | null = null;
  isAuto?: boolean = false;
  forPrevDay?: boolean = false;
  tnADetail: TnADateTime | null = null;
  isRealTimeClocking = false;
  tnALocationCode: TnALocationCodeRef | null = null;
  tnALocationCodeOrName: string | null = null;
  tnAClockingLocationQRCode: TnAClockingLocationQRCodeRef | null = null;
  signature = "";

  public static ClockingString = (tnADetail: TnADateTime | null) => {
    if (!tnADetail) return "";

    const hours = formatUnitOfTime(tnADetail.hour);
    const minutes = formatUnitOfTime(tnADetail.minute);

    return `${hours}:${minutes}`;
  };
}
